import * as React from "react"

import { cn } from "@/lib/utils"

// Plain-img based avatar: reliably renders cached images (Radix Avatar.Image
// gets stuck on the fallback for already-cached photos) and always uses
// object-cover + object-top so faces are centred and never squished.
const Avatar = React.forwardRef(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={cn("relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full", className)}
    {...props} />
))
Avatar.displayName = "Avatar"

const AvatarImage = React.forwardRef(({ className, src, alt = "", ...props }, ref) => {
  const [ok, setOk] = React.useState(true)
  React.useEffect(() => { setOk(true) }, [src])
  if (!src || !ok) return null
  return (
    <img
      ref={ref}
      src={src}
      alt={alt}
      onError={() => setOk(false)}
      className={cn("absolute inset-0 h-full w-full object-cover object-top", className)}
      {...props} />
  )
})
AvatarImage.displayName = "AvatarImage"

const AvatarFallback = React.forwardRef(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={cn(
      "flex h-full w-full items-center justify-center rounded-full bg-muted",
      className
    )}
    {...props} />
))
AvatarFallback.displayName = "AvatarFallback"

export { Avatar, AvatarImage, AvatarFallback }
